import url from './url';



export default url(() => '/error/error-v4');
